export const validateValor = value => {
  if (!value) return undefined

  return Number(value) || undefined
}
